var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedium = function SvgMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M13.011 11.625A4.883 4.883 0 0 1 8.12 16.5h-.001a4.9 4.9 0 0 1-1.87-.37l-.285.694.286-.693a4.88 4.88 0 0 1-3.02-4.507A4.88 4.88 0 0 1 8.12 6.75a4.883 4.883 0 0 1 4.891 4.875Zm6.188 0c0 1.364-.297 2.562-.738 3.392-.46.862-.966 1.153-1.332 1.153s-.873-.291-1.333-1.154c-.441-.83-.737-2.027-.737-3.391s.296-2.562.737-3.392c.46-.862.966-1.153 1.332-1.153s.873.291 1.333 1.154c.441.83.738 2.027.738 3.391Zm2.53 0c0 1.189-.094 2.254-.241 3.036-.148-.782-.242-1.848-.242-3.036 0-1.189.094-2.254.242-3.036.147.782.242 1.847.242 3.036Z"
  })));
};
export default SvgMedium;